import { BILL_RATE_TYPES } from '@/lib/constants/billRateTypes'

let getBillRateTypeLabel = (billRateTypeId) => {
  return BILL_RATE_TYPES[billRateTypeId]
}

export default getBillRateTypeLabel
